import { forwardRef } from "react";
import { ProductCardProps } from "./ProductCard.type";
import { Default } from "./variations/Default";
import { Extended } from "./variations/Extended";

export const ProductCard = forwardRef<HTMLDivElement, ProductCardProps>((props, ref) => {
  const cardSize = props.galleryCardSize || props.product?.fields?.product_card_size;
  const isExtended = cardSize?.toLowerCase().includes("extended");

  if (isExtended) return <Extended {...props} ref={ref} />;
  return <Default {...props} ref={ref} />;
});

ProductCard.displayName = "ProductCard";
